import { Upload, Search, FileText, Inbox, UserRound } from "lucide-react";

export const PORTAL_FEATURE_NAV = {
  UPLOAD_DOCUMENT: {
    group: null,
    sortOrder: 10,
    dashboardDesc: "Upload a new policy or claim document",
    icon: Upload,
  },
  SEARCH_DOC: {
    group: null,
    sortOrder: 20,
    dashboardDesc: "Find documents across the portal",
    icon: Search,
  },
  ARCHIVAL_POLICY_SEARCH: {
    group: null,
    sortOrder: 30,
    dashboardDesc: "Look up archived policy records",
    icon: FileText,
  },
  ARCHIVAL_CLAIM_SEARCH: {
    group: null,
    sortOrder: 35,
    dashboardDesc: "Look up archived claim records",
    icon: FileText,
  },
  DOC_INDEX_HUB: {
    group: "Document Index Hub",
    sortOrder: 40,
    dashboardDesc: "Review new inbox documents",
    icon: Inbox,
  },
  TEAM_INBOX: {
    group: "Document Index Hub",
    sortOrder: 38,
    dashboardDesc: "Review and assign your team's queue",
    icon: Inbox,
  },
  WORK_ITEMS: {
    group: "Document Index Hub",
    sortOrder: 39,
    dashboardDesc: "Open the work assigned to you",
    icon: UserRound,
  },
};

// Temporary. Set to false to show Inbox Review in the menu and on /document-hub.
export const HIDE_INBOX_REVIEW = true;

const DEFAULT_NAV_META = {
  group: null,
  sortOrder: 999,
  dashboardDesc: "",
  icon: null,
};

export function getPortalFeatureMeta(resourceCode, resourceName) {
  const configured = PORTAL_FEATURE_NAV[resourceCode] || DEFAULT_NAV_META;
  const label = resourceName?.trim() || resourceCode;

  return {
    navLabel: label,
    group: configured.group,
    sortOrder: configured.sortOrder,
    dashboardTitle: label,
    dashboardDesc: configured.dashboardDesc,
    icon: configured.icon,
  };
}

export function buildPortalNavigation(features = []) {
  const enriched = features
    .filter((feature) => PORTAL_FEATURE_NAV[feature.resource_code])
    .map((feature) => {
      const meta = getPortalFeatureMeta(
        feature.resource_code,
        feature.resource_name,
      );

      return {
        resource_code: feature.resource_code,
        resource_path: feature.resource_path,
        navLabel: meta.navLabel,
        group: meta.group,
        sortOrder: meta.sortOrder,
        dashboardTitle: meta.dashboardTitle,
        dashboardDesc: meta.dashboardDesc,
        icon: meta.icon,
      };
    })
    .sort((a, b) => a.sortOrder - b.sortOrder);

  const topLevel = enriched.filter((item) => !item.group);
  const groupedItems = enriched.filter((item) => item.group);
  const groupMap = new Map();

  groupedItems.forEach((item) => {
    if (!groupMap.has(item.group)) {
      groupMap.set(item.group, []);
    }

    groupMap.get(item.group).push(item);
  });

  const groups = Array.from(groupMap.entries()).map(([groupLabel, items]) => ({
    groupLabel,
    items,
  }));

  return { topLevel, groups };
}

export function buildDashboardModules(features = []) {
  const { topLevel, groups } = buildPortalNavigation(features);
  const items = topLevel.concat(...groups.map((group) => group.items));

  return items
    .filter((item) => item.icon)
    .map((item) => ({
      key: item.resource_code,
      title: item.dashboardTitle,
      desc: item.dashboardDesc,
      path: item.resource_path,
      icon: item.icon,
    }));
}
